import { CareerHubBreadCrumb } from '@xing-com/crate-career-hub-common';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { TopBar } from '@xing-com/crate-layout-top-bar';

export type HeaderNavigationType = {
  title: string;
};

export const HeaderNavigation: React.FC<HeaderNavigationType> = ({ title }) => {
  const { isLoggedOut } = useLoginState();

  return isLoggedOut ? (
    <CareerHubBreadCrumb />
  ) : (
    <TopBar type="subheaderS" {...{ title }} skipBackButton />
  );
};
